// import Vue from 'vue'
import consts from "@/consts"
import {diffObjects, getApiProps, updateObjectByDiff} from "@/lib/lib";
import range from "lodash/range";
// import {updateObjectByDiff} from "@/lib/lib";
const changedField = 'changed__time';

export default {
    state: {
        unitsLmsgsLiteLoad: false,
        unitsLmsgsFullLoad: false,
        unitsLmsgs: {},
        unitsLmsgsTimeAgo: {},
    },
    actions: {
        fetchUnitsLmsgs/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUnitsLmsgs', args, time: Date.now() / 1000})

                const params = getApiProps('unitslmsgs', args)
                let data = {...args}
                if (args?.lite) params.withAddress = data.withAddress = 0;
                if (!args?.force) params['filter[changed]'] = data['filter[changed]'] = getters.getUnitsLmsgsChangedTimeMax
                this.$api.units.getLmsgs(data, {...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitsLmsgs', args, inprogress: false})
                    });
            })
        },
        fetchUnitsLmsgsAll({dispatch, commit}) {
            return new Promise((resolve, reject) => {
                this.$api.init.getUnitsLmsgs()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setUnitsLmsgs', response.data)
                            commit('setUnitsLmsgsLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUnitsLmsgsAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUnitsLmsgsAllLite({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (getters.isUnitsLmsgsLiteLoad) {
                    return resolve(getters.getUnits.length)//!!!
                }
                dispatch('fetchUnitsLmsgs', {lite: true, force: true, ...args})
                    .then((data) => {
                        commit('updateUnitsLmsgs', data)
                        commit('setUnitsLmsgsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchUnitsLmsgsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchUnitsLmsgsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchUnitsLmsgsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchUnitsLmsgsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getUnits.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getUnits.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchUnitsLmsgs', {page, 'page-size': pageSize, force: true, ...args})
                            .then((data) => {
                                commit('updateUnitsLmsgs', data)
                            })
                            .catch(() => {
                                dispatch('fetchUnitsLmsgs', {page, 'page-size': pageSize, force: true, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setUnitsLmsgsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchUnitsLmsgsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchUnitsLmsgsChanged', args, inprogress: false})
                })
        },
        fetchUnitsLmsgsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isUnitsLmsgsFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchUnitsLmsgsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchUnitsLmsgs', args)
                .then((data) => {
                    commit('updateUnitsLmsgs', data)
                    // return dispatch('fetchUnitsLmsgs', {fields: 'object_id',expand: '', force: true})
                })
                // .then((data) => {
                //     commit('filterUnitsLmsgs', data)
                // })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchUnitsLmsgsChanged', args, inprogress: false})
                });
        },
        reloadUnitsLmsgsAll({commit, dispatch}, args) {
            commit('clearUnitsLmsgs')
            return dispatch('fetchUnitsLmsgsAllLite', args)
                .then(() => {
                    dispatch('fetchUnitsLmsgsAllPages', args)
                })
        },

        fetchUnitLmsg({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUnitLmsg', args, time: Date.now() / 1000})

                let lmsg = getters.getUnitsLmsgsByIds[args.unitId] || {}
                let changed = lmsg[changedField] || ''
                let params = {'filter[changed]': changed, withAddress: 1, ...args}
                delete params.unitId;
                this.$api.units.getLmsg(args.unitId, params)
                    .then((response) => {
                        if (response.status < 400 && response.data && !response.data?.error) {
                            commit('updateUnitLmsg', response.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUnitLmsg', args, inprogress: false})
                    });
            })
        },

        updateUnitCounters({/*dispatch,*/ commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.unitId) {
                    return reject(false)
                }

                //dispatch('setLastCall', {name: 'updateUnitCounters', args, time: Date.now() / 1000})

                const params = getApiProps('unitslmsgs', args)
                delete params.unitId;delete params.counters;
                this.$api.units.updateCounters(args.unitId, args.counters, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            // console.log(response.data)
                            commit('updateUnitLmsg', response.data)
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    })
                    .finally(() => {
                        //dispatch('setLastCall', {name: 'updateUnitCounters', args, inprogress: false})
                    });
            })
        },

        incrementUnitsLmsgTimeAgo({commit}) {
            commit('incrementUnitsLmsgTimeAgo')
        },

        //sayHello() {}
    },
    mutations: {
        setUnitsLmsgsLiteLoad(state, LiteLoad) {
            state.unitsLmsgsLiteLoad = state.unitsLmsgsLiteLoad || LiteLoad
        },
        setUnitsLmsgsFullLoad(state, FullLoad) {
            state.unitsLmsgsFullLoad = state.unitsLmsgsFullLoad || FullLoad
        },

        setUnitsLmsgs(state, nLmsgs) {
            state.unitsLmsgs = nLmsgs.reduce((lmsgsByIds, nLmsg) => {
                lmsgsByIds[nLmsg.object_id] = Object.freeze(nLmsg)
                return lmsgsByIds
            }, {})
            //Lmsgs TimeAgo
            state.unitsLmsgsTimeAgo = nLmsgs.reduce((lmsgsByIds, nLmsg) => {
                lmsgsByIds[nLmsg.object_id] = {object_id: nLmsg.object_id, time: nLmsg.time, timeAgo: nLmsg.timeAgo, isActive: nLmsg.timeAgo < consts.status.offline}
                return lmsgsByIds
            }, {})
        },

        updateUnitsLmsgs(state, nLmsgs) {
            if (!Object.keys(state.unitsLmsgs).length) {
                state.unitsLmsgs = nLmsgs.reduce((lmsgsByIds, nLmsg) => {
                    lmsgsByIds[nLmsg.object_id] = Object.freeze(nLmsg)
                    return lmsgsByIds
                }, {})
                //Lmsgs TimeAgo
                state.unitsLmsgsTimeAgo = nLmsgs.reduce((lmsgsByIds, nLmsg) => {
                    lmsgsByIds[nLmsg.object_id] = {object_id: nLmsg.object_id, time: nLmsg.time, timeAgo: nLmsg.timeAgo, isActive: nLmsg.timeAgo < consts.status.offline}
                    return lmsgsByIds
                }, {})
                return true
            }
            //console.log('updateLmsgs', Object.keys(state.unitsLmsgs).length, nLmsgs.length)
            nLmsgs.forEach((nLmsg) => {
                let object_id = nLmsg.object_id
                let lmsg = state.unitsLmsgs[object_id]
                if (!lmsg) {
                    state.unitsLmsgs[object_id] = Object.freeze(nLmsg)
                } else
                if (!state.unitsLmsgsFullLoad || (lmsg[changedField] != nLmsg[changedField])) {
                    // updateObjectByDiff(state.unitsLmsgs[object_id], nLmsg)
                    // delete nLmsg.object_id
                    let newLmsg = diffObjects(lmsg, nLmsg) || {}
                    state.unitsLmsgs[object_id] = Object.freeze({...lmsg, ...newLmsg})
                }
                //Lmsgs TimeAgo
                nLmsg = {object_id, time: nLmsg.time, timeAgo: nLmsg.timeAgo, isActive: nLmsg.timeAgo < consts.status.offline}
                lmsg = state.unitsLmsgsTimeAgo[object_id]
                if (!lmsg) {
                    state.unitsLmsgsTimeAgo[object_id] = (nLmsg)
                } else {
                    updateObjectByDiff(state.unitsLmsgsTimeAgo[object_id], nLmsg)
                    // delete nLmsg.object_id
                    // nLmsg = diffObjects(lmsg, nLmsg) || {}
                    // state.unitsLmsgsTimeAgo[lmsg.object_id] = {...lmsg, ...nLmsg}
                }
            })
        },
        filterUnitsLmsgs(state, nLmsgs) {
            let nIds = new Set(nLmsgs.map(l => String(l.object_id)))
            Object.keys(state.unitsLmsgs).forEach(id => {
                if (!nIds.has(id)) {
                    delete state.unitsLmsgs[id]
                    delete state.unitsLmsgsTimeAgo[id]
                }
            })
        },
        updateUnitLmsg(state, nLmsg) {
            if (!nLmsg) return;
            let object_id = nLmsg.object_id
            let lmsg = state.unitsLmsgs[object_id]
            if (!lmsg) {
                state.unitsLmsgs[object_id] = Object.freeze(nLmsg)
            } else
            //if (!state.unitsLmsgsFullLoad || (!nLmsg[changedField] || lmsg[changedField] < nLmsg[changedField]))
            {
                // updateObjectByDiff(state.unitsLmsgs[object_id], nLmsg)
                // delete nLmsg.object_id
                let newLmsg = diffObjects(lmsg, nLmsg) || {}
                if (Object.keys(newLmsg).length) {
                    state.unitsLmsgs[object_id] = Object.freeze({...lmsg, ...newLmsg})
                }
            }
            //Lmsgs TimeAgo
            nLmsg = {object_id, time: nLmsg.time, timeAgo: nLmsg.timeAgo, isActive: nLmsg.timeAgo < consts.status.offline}
            lmsg = state.unitsLmsgsTimeAgo[nLmsg.object_id]
            if (!lmsg) {
                state.unitsLmsgsTimeAgo[nLmsg.object_id] = (nLmsg)
            } else {
                updateObjectByDiff(state.unitsLmsgsTimeAgo[object_id], nLmsg)
                // delete nLmsg.object_id
                // nLmsg = diffObjects(lmsg, nLmsg) || {}
                // state.unitsLmsgsTimeAgo[lmsg.object_id] = {...lmsg, ...nLmsg}
            }
        },

        clearUnitsLmsgs(state, {unitId} = {}) {
            if (unitId) {
                delete state.unitsLmsgs[unitId]
                delete state.unitsLmsgsTimeAgo[unitId]
            } else {
                state.unitsLmsgs = {}
                state.unitsLmsgsTimeAgo = {}
                state.unitsLmsgsLiteLoad = false
                state.unitsLmsgsFullLoad = false
            }
        },

        incrementUnitsLmsgTimeAgo(state) {
            Object.values(state.unitsLmsgsTimeAgo).forEach(lmsg => {
                if (typeof lmsg.timeAgo === 'number') {
                    lmsg.timeAgo++

                    let isOnline = (lmsg.timeAgo <= consts.status.online)
                    let isOffline = (lmsg.timeAgo > consts.status.offline)

                    lmsg.isActive = (lmsg.timeAgo < consts.status.offline)
                    lmsg.isOnline = isOnline
                    lmsg.isOffline = isOffline
                    lmsg.onlineStatus = (isOnline ? 'online' : isOffline ? 'offline' : 'online-recently')
                }
            })
        },
    },
    getters: {
        isUnitsLmsgsLiteLoad(state) {
            return state.unitsLmsgsLiteLoad
        },
        isUnitsLmsgsFullLoad(state) {
            return state.unitsLmsgsFullLoad
        },
        getUnitsLmsgsTimeAgo(state) {
            return Object.values(state.unitsLmsgsTimeAgo)
        },
        getUnitsLmsgs(state) {
            return Object.values(state.unitsLmsgs)
        },
        getUnitsLmsgsIds(state) {
            return Object.keys(state.unitsLmsgs)
        },
        getUnitsIdsIsLmsgFullLoad(state) {
            return Object.values(state.unitsLmsgs)
                .filter(lmsg => (typeof lmsg[changedField] !== 'undefined'))//!!!???
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsMoving(state) {
            return Object.values(state.unitsLmsgs)
                .filter(lmsg => lmsg?.status?.isMoving === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsParked(state) {
            return Object.values(state.unitsLmsgs)
                .filter(lmsg => lmsg?.status?.isParked === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsIgnitionOn(state) {
            return Object.values(state.unitsLmsgs)
                .filter(lmsg => lmsg?.status?.ignition === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsActive(state) {
            return Object.values(state.unitsLmsgsTimeAgo)
                .filter(lmsg => lmsg.isActive === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsNotActive(state) {
            return Object.values(state.unitsLmsgsTimeAgo)
                .filter(lmsg => lmsg.isActive === false)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsOnline(state) {
            return Object.values(state.unitsLmsgsTimeAgo)
                .filter(lmsg => lmsg.isOnline === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsIdsIsOffline(state) {
            return Object.values(state.unitsLmsgsTimeAgo)
                .filter(lmsg => lmsg.isOffline === true)
                .map(lmsg => lmsg.object_id)
        },
        getUnitsLmsgsChangedTimeMax(state) {
            return Object.values(state.unitsLmsgs)
                .map(lmsg => lmsg[changedField])
                .filter(t => !!t)
                .reduce((a, b) => (a > b ? a : b), 0)
        },
        getUnitsLmsgsLatlngByIds(state, getters) {
            return Object.values(state.unitsLmsgs).reduce((latlngBylmsgIds, lmsg) => {
                let unit = getters.getUnitsByIds[lmsg.object_id]
                if (lmsg?.latlng?.lat || lmsg?.latlng?.lng) {
                    latlngBylmsgIds[lmsg.object_id] = lmsg.latlng
                } else
                if(unit?.coords) {
                    latlngBylmsgIds[lmsg.object_id] = unit?.coords
                }
                return latlngBylmsgIds
            }, {})
        },
        getUnitsLmsgsAddressByIds(state) {
            return Object.values(state.unitsLmsgs).reduce((addressBylmsgIds, lmsg) => {
                let address = lmsg.address
                if (!lmsg?.address && lmsg?.latlng) {
                    address = `lat: ${lmsg.latlng.lat}, lon: ${lmsg.latlng.lng}`
                    //lmsg = {...lmsg, address}
                }
                addressBylmsgIds[lmsg.object_id] = address
                return addressBylmsgIds
            }, {})
        },

        getUnitsLmsgsByIds(state) {
            return state.unitsLmsgs
        },

        getUnitsSensorsListById(state) {
            return Object.values(state.unitsLmsgs).reduce((sensorsByIds, lmsg) => {
                sensorsByIds[lmsg.object_id] = Object.keys(lmsg?.sensors || {})
                    .map(sensor => {
                        return {name: sensor, ...lmsg?.sensors[sensor]}
                    })
                return sensorsByIds
            }, {})
        },

        getUnitsLmsgsTimeAgoByIds(state) {
            return state.unitsLmsgsTimeAgo
        },
    }
}
